export default __webpack_public_path__ + "static/media/ExportTheme.47e4f7a5.svg";